// passing the path into variables

const banner1 = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Slide-Desktop-1.jpg';

const destination1 = '/assets/busesahumada/Destinations/BusesAhumada-Website-Destinations1.png';
const destination2 = '/assets/busesahumada/Destinations/BusesAhumada-Website-Destinations2.png';
const destination3 = '/assets/busesahumada/Destinations/BusesAhumada-Website-Destinations3.png';
const destination4 = '/assets/busesahumada/Destinations/BusesAhumada-Website-Destinations4.png';

const gallery1 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-1.jpg';
const gallery2 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-2.jpg';
const gallery3 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-3.jpg';
const gallery4 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-4.jpg';
const gallery5 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-5.jpg';
const gallery6 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-6.jpg';
const gallery7 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-7.jpg';
const gallery8 = '/assets/bahia/Gallery/BahiaAzul-Website-Gallery-8.jpg';

const banner = [banner1];

const destination = [
  destination1,
  destination2,
  destination3,
  destination4,
];

const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8];

const busesahumadaSlides = {
  banner,
  destination,
  gallery,
};

export default busesahumadaSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/busesahumadaSlides.js